import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const projectUsersSlice = createSlice({
  name: "projectUsers",
  initialState: [],
  reducers: {
    setProjectUserDetails: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const spaceUsersSlice = createSlice({
  name: "spaceUsers",
  initialState: [],
  reducers: {
    setSpaceUserDetails: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

const userInProjectSlice = createSlice({
  name: "userInProject",
  initialState: [],
  reducers: {
    setUsersInProject: (_state: any, action: PayloadAction<any>) => action.payload,
  },
});

export const { setProjectUserDetails } = projectUsersSlice.actions;
export const { setSpaceUserDetails } = spaceUsersSlice.actions;
export const { setUsersInProject } = userInProjectSlice.actions;

export const projectUsers = projectUsersSlice.reducer;
export const spaceUsers = spaceUsersSlice.reducer;
export const UserInProject = userInProjectSlice.reducer;

export default projectUsersSlice.reducer;
